import { render, staticRenderFns } from "./DamageEvent.vue?vue&type=template&id=32eb7ee9&"
import script from "./DamageEvent.vue?vue&type=script&lang=js&"
export * from "./DamageEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports